<template>
  <v-container fluid>
    <div class="d-flex mb-2">
      <h2 style="font-weight: 400">การคิดชั่วโมงงาน</h2>
    </div>
    <v-tabs v-model="tab" background-color="transparent">
      <v-tab>การคิดชั่วโมงงาน</v-tab>
      <v-tab>การให้ชั่วโมง</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item
        class="pa-4"
        style="height: calc(100vh - 215px); overflow-y: auto"
      >
        <v-card outlined class="pa-4" style="width: 100%">
          <v-row no-gutters>
            <v-col cols="12" md="4" lg="3" class="pr-6">
              <p class="body-2 mb-1" style="font-weight: 500">
                ชั่วโมงงาน ต่อ วัน
              </p>
              <div class="d-flex mb-6">
                <div class="mr-4">
                  <label class="caption">ชั่วโมง</label>
                  <v-text-field
                    v-model.number="
                      configWorkingHours.working_hours_config.working_hours.hour
                    "
                    :rules="[
                      validationRules.required,
                      validationRules.positiveInteger,
                      validationRules.maxHours(23),
                    ]"
                    type="number"
                    min="1"
                    max="23"
                    outlined
                    dense
                    hide-details
                    style="width: 100px"
                  ></v-text-field>
                </div>
                <div>
                  <label class="caption">นาที</label>
                  <v-text-field
                    v-model.number="
                      configWorkingHours.working_hours_config.working_hours
                        .minute
                    "
                    :rules="[
                      validationRules.required,
                      validationRules.nonNegativeInteger,
                      validationRules.maxMinutes(59),
                    ]"
                    type="number"
                    min="0"
                    max="59"
                    outlined
                    dense
                    hide-details
                    style="width: 100px"
                  ></v-text-field>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="4" lg="3">
              <p class="body-2 mb-1" style="font-weight: 500">
                จำนวนวัน ต่อ งวด(รายเดือน)
              </p>
              <div class="mb-6">
                <label class="caption">วัน</label>
                <v-text-field
                  v-model.number="
                    configWorkingHours.working_hours_config.day_period.day
                  "
                  :rules="[
                    validationRules.required,
                    validationRules.positiveInteger,
                    validationRules.maxDays(31),
                  ]"
                  type="number"
                  min="1"
                  max="31"
                  outlined
                  dense
                  hide-details
                  style="width: 100px"
                ></v-text-field>
              </div>
            </v-col>
          </v-row>

          <v-divider class="my-4"></v-divider>

          <v-row no-gutters>
            <v-col cols="12" md="4" lg="3" class="pr-6">
              <div>
                <h2 class="body-2" style="font-weight: 500">คิดมาทำงานจาก</h2>
                <div
                  class="mt-1"
                  style="display: flex; flex-direction: column; gap: 4px"
                >
                  <div
                    class="d-flex align-items-center"
                    v-for="attendanceRule in configWorkingHours.attendance_rule"
                    :key="attendanceRule.code"
                  >
                    <input
                      type="radio"
                      :id="attendanceRule.code"
                      :value="attendanceRule.code"
                      v-model="
                        configWorkingHours.working_hours_config.attendance_rule
                      "
                    />
                    <label class="ml-2 body-2" :for="attendanceRule.code">
                      {{ attendanceRule.title_th }}
                    </label>
                  </div>
                </div>
              </div>
              <div class="mt-4 mb-4">
                <h2 class="body-2" style="font-weight: 500">เริ่มคิดสายจาก</h2>
                <div
                  class="mt-1"
                  style="display: flex; flex-direction: column; gap: 4px"
                >
                  <div
                    class="d-flex align-items-center"
                    v-for="startLateFrom in configWorkingHours.start_late_from"
                    :key="startLateFrom.code"
                  >
                    <input
                      type="radio"
                      :id="startLateFrom.code"
                      :value="startLateFrom.code"
                      v-model="
                        configWorkingHours.working_hours_config.start_late_from
                      "
                    />
                    <label class="ml-2 body-2" :for="startLateFrom.code">
                      {{ startLateFrom.title_th }}
                    </label>
                  </div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="4" lg="3">
              <div>
                <h2 class="body-2" style="font-weight: 500">กรณีลางาน</h2>
                <div
                  class="mt-1"
                  style="display: flex; flex-direction: column; gap: 4px"
                >
                  <div class="d-flex align-items-center">
                    <input
                      type="checkbox"
                      id="deduct_hours_on_leave"
                      v-model="
                        configWorkingHours.working_hours_config
                          .deduct_hours_on_leave
                      "
                    />
                    <label class="ml-2 body-2" for="deduct_hours_on_leave">
                      หักชั่วโมงงาน
                    </label>
                  </div>
                  <div class="d-flex align-items-center">
                    <input
                      type="checkbox"
                      id="ignore_late_early_on_leave"
                      v-model="
                        configWorkingHours.working_hours_config
                          .ignore_late_early_on_leave
                      "
                    />
                    <label class="ml-2 body-2" for="ignore_late_early_on_leave">
                      ลบสาย-กลับก่อน
                    </label>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card>
        <div class="mt-6">
          <v-btn
            class="mr-4"
            color="primary"
            :disabled="
              !isConfigWorkingHoursDataChange ||
              (uiCtrl &&
                !uiCtrl.isEnable('btn:::company_config:working_hours:update'))
            "
            @click="onSaveConfigWorkingHours"
            >บันทึก</v-btn
          >
          <v-btn @click="resetConfigWorkingHours">ยกเลิก</v-btn>
        </div>
      </v-tab-item>
      <v-tab-item
        class="pa-4"
        style="height: calc(100vh - 215px); overflow-y: auto"
      >
        <v-card outlined class="pa-4">
          <div>
            <p class="body-2 mb-0" style="font-weight: 600">การให้ชั่วโมงงาน</p>
            <v-divider class="my-2"></v-divider>
            <p class="body-2 mb-1" style="font-weight: 500">พนักงานรายวัน</p>
            <div class="mt-2 d-flex">
              <table>
                <tbody>
                  <tr>
                    <td class="px-4 py-1 body-2 text-right grey lighten-3">
                      วันทำงานมา
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="granted_daily_workday_present_true"
                        :value="true"
                        v-model="
                          configWorkingHours.working_hours_config
                            .granted_work_hour_rules.daily_employee
                            .workday_present_granted
                        "
                      />
                      <label
                        for="granted_daily_workday_present_true"
                        class="ml-2"
                        >{{
                          `${configWorkingHours.working_hours_config.working_hours.hour}.${configWorkingHours.working_hours_config.working_hours.minute}`
                        }}
                        ช.ม.
                      </label>
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="granted_daily_workday_present_false"
                        :value="false"
                        v-model="
                          configWorkingHours.working_hours_config
                            .granted_work_hour_rules.daily_employee
                            .workday_present_granted
                        "
                      />
                      <label
                        for="granted_daily_workday_present_false"
                        class="ml-2"
                        >ไม่ให้</label
                      >
                    </td>
                  </tr>
                  <tr>
                    <td class="px-4 py-1 body-2 text-right grey lighten-3">
                      วันหยุดมา
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="granted_daily_day_off_present_true"
                        :value="true"
                        v-model="
                          configWorkingHours.working_hours_config
                            .granted_work_hour_rules.daily_employee
                            .day_off_present_granted
                        "
                      />
                      <label
                        for="granted_daily_day_off_present_true"
                        class="ml-2"
                        >{{
                          `${configWorkingHours.working_hours_config.working_hours.hour}.${configWorkingHours.working_hours_config.working_hours.minute}`
                        }}
                        ช.ม.</label
                      >
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="granted_daily_day_off_present_false"
                        :value="false"
                        v-model="
                          configWorkingHours.working_hours_config
                            .granted_work_hour_rules.daily_employee
                            .day_off_present_granted
                        "
                      />
                      <label
                        for="granted_daily_day_off_present_false"
                        class="ml-2"
                        >ไม่ให้</label
                      >
                    </td>
                  </tr>
                  <tr>
                    <td class="px-4 py-1 body-2 text-right grey lighten-3">
                      วันนักขัติฯมา
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="granted_daily_public_holiday_present_true"
                        :value="true"
                        v-model="
                          configWorkingHours.working_hours_config
                            .granted_work_hour_rules.daily_employee
                            .public_holiday_present_granted
                        "
                      />
                      <label
                        for="granted_daily_public_holiday_present_true"
                        class="ml-2"
                        >{{
                          `${configWorkingHours.working_hours_config.working_hours.hour}.${configWorkingHours.working_hours_config.working_hours.minute}`
                        }}
                        ช.ม.</label
                      >
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="granted_daily_public_holiday_present_false"
                        :value="false"
                        v-model="
                          configWorkingHours.working_hours_config
                            .granted_work_hour_rules.daily_employee
                            .public_holiday_present_granted
                        "
                      />
                      <label
                        for="granted_daily_public_holiday_present_false"
                        class="ml-2"
                        >ไม่ให้</label
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
              <v-divider vertical class="mx-6"></v-divider>
              <table>
                <tbody>
                  <tr>
                    <td class="px-4 py-1 body-2 text-right grey lighten-3">
                      วันทำงานไม่มา
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="granted_daily_workday_absent_true"
                        :value="true"
                        v-model="
                          configWorkingHours.working_hours_config
                            .granted_work_hour_rules.daily_employee
                            .workday_absent_granted
                        "
                      />
                      <label
                        for="granted_daily_workday_absent_true"
                        class="ml-2"
                        >{{
                          `${configWorkingHours.working_hours_config.working_hours.hour}.${configWorkingHours.working_hours_config.working_hours.minute}`
                        }}
                        ช.ม.</label
                      >
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="granted_daily_workday_absent_false"
                        :value="false"
                        v-model="
                          configWorkingHours.working_hours_config
                            .granted_work_hour_rules.daily_employee
                            .workday_absent_granted
                        "
                      />
                      <label
                        for="granted_daily_workday_absent_false"
                        class="ml-2"
                        >ไม่ให้</label
                      >
                    </td>
                  </tr>
                  <tr>
                    <td class="px-4 py-1 body-2 text-right grey lighten-3">
                      วันหยุดไม่มา
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="granted_daily_day_off_absent_true"
                        :value="true"
                        v-model="
                          configWorkingHours.working_hours_config
                            .granted_work_hour_rules.daily_employee
                            .day_off_absent_granted
                        "
                      />
                      <label
                        for="granted_daily_day_off_absent_true"
                        class="ml-2"
                        >{{
                          `${configWorkingHours.working_hours_config.working_hours.hour}.${configWorkingHours.working_hours_config.working_hours.minute}`
                        }}
                        ช.ม.</label
                      >
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="granted_daily_day_off_absent_false"
                        :value="false"
                        v-model="
                          configWorkingHours.working_hours_config
                            .granted_work_hour_rules.daily_employee
                            .day_off_absent_granted
                        "
                      />
                      <label
                        for="granted_daily_day_off_absent_false"
                        class="ml-2"
                        >ไม่ให้</label
                      >
                    </td>
                  </tr>
                  <tr>
                    <td class="px-4 py-1 body-2 text-right grey lighten-3">
                      วันนักขัติฯไม่มา
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="granted_daily_public_holiday_absent_true"
                        :value="true"
                        v-model="
                          configWorkingHours.working_hours_config
                            .granted_work_hour_rules.daily_employee
                            .public_holiday_absent_granted
                        "
                      />
                      <label
                        for="granted_daily_public_holiday_absent_true"
                        class="ml-2"
                        >{{
                          `${configWorkingHours.working_hours_config.working_hours.hour}.${configWorkingHours.working_hours_config.working_hours.minute}`
                        }}
                        ช.ม.</label
                      >
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="granted_daily_public_holiday_absent_false"
                        :value="false"
                        v-model="
                          configWorkingHours.working_hours_config
                            .granted_work_hour_rules.daily_employee
                            .public_holiday_absent_granted
                        "
                      />
                      <label
                        for="granted_daily_public_holiday_absent_false"
                        class="ml-2"
                        >ไม่ให้</label
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="mt-10">
            <p class="body-2 mb-1" style="font-weight: 500">พนักงานรายเดือน</p>
            <div class="mt-2 d-flex">
              <table>
                <tbody>
                  <tr>
                    <td class="px-4 py-1 body-2 text-right grey lighten-3">
                      วันทำงานมา
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="granted_monthly_workday_present_true"
                        :value="true"
                        v-model="
                          configWorkingHours.working_hours_config
                            .granted_work_hour_rules.monthly_employee
                            .workday_present_granted
                        "
                      />
                      <label
                        for="granted_monthly_workday_present_true"
                        class="ml-2"
                        >{{
                          `${configWorkingHours.working_hours_config.working_hours.hour}.${configWorkingHours.working_hours_config.working_hours.minute}`
                        }}
                        ช.ม.</label
                      >
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="granted_monthly_workday_present_false"
                        :value="false"
                        v-model="
                          configWorkingHours.working_hours_config
                            .granted_work_hour_rules.monthly_employee
                            .workday_present_granted
                        "
                      />
                      <label
                        for="granted_monthly_workday_present_false"
                        class="ml-2"
                        >ไม่ให้</label
                      >
                    </td>
                  </tr>
                  <tr>
                    <td class="px-4 py-1 body-2 text-right grey lighten-3">
                      วันหยุดมา
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="granted_monthly_day_off_present_true"
                        :value="true"
                        v-model="
                          configWorkingHours.working_hours_config
                            .granted_work_hour_rules.monthly_employee
                            .day_off_present_granted
                        "
                      />
                      <label
                        for="granted_monthly_day_off_present_true"
                        class="ml-2"
                        >{{
                          `${configWorkingHours.working_hours_config.working_hours.hour}.${configWorkingHours.working_hours_config.working_hours.minute}`
                        }}
                        ช.ม.</label
                      >
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="granted_monthly_day_off_present_false"
                        :value="false"
                        v-model="
                          configWorkingHours.working_hours_config
                            .granted_work_hour_rules.monthly_employee
                            .day_off_present_granted
                        "
                      />
                      <label
                        for="granted_monthly_day_off_present_false"
                        class="ml-2"
                        >ไม่ให้</label
                      >
                    </td>
                  </tr>
                  <tr>
                    <td class="px-4 py-1 body-2 text-right grey lighten-3">
                      วันนักขัติฯมา
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="granted_monthly_public_holiday_present_true"
                        :value="true"
                        v-model="
                          configWorkingHours.working_hours_config
                            .granted_work_hour_rules.monthly_employee
                            .public_holiday_present_granted
                        "
                      />
                      <label
                        for="granted_monthly_public_holiday_present_true"
                        class="ml-2"
                        >{{
                          `${configWorkingHours.working_hours_config.working_hours.hour}.${configWorkingHours.working_hours_config.working_hours.minute}`
                        }}
                        ช.ม.</label
                      >
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="granted_monthly_public_holiday_present_false"
                        :value="false"
                        v-model="
                          configWorkingHours.working_hours_config
                            .granted_work_hour_rules.monthly_employee
                            .public_holiday_present_granted
                        "
                      />
                      <label
                        for="granted_monthly_public_holiday_present_false"
                        class="ml-2"
                        >ไม่ให้</label
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
              <v-divider vertical class="mx-6"></v-divider>
              <table>
                <tbody>
                  <tr>
                    <td class="px-4 py-1 body-2 text-right grey lighten-3">
                      วันทำงานไม่มา
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="granted_monthly_workday_absent_true"
                        :value="true"
                        v-model="
                          configWorkingHours.working_hours_config
                            .granted_work_hour_rules.monthly_employee
                            .workday_absent_granted
                        "
                      />
                      <label
                        for="granted_monthly_workday_absent_true"
                        class="ml-2"
                        >{{
                          `${configWorkingHours.working_hours_config.working_hours.hour}.${configWorkingHours.working_hours_config.working_hours.minute}`
                        }}
                        ช.ม.</label
                      >
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="granted_monthly_workday_absent_false"
                        :value="false"
                        v-model="
                          configWorkingHours.working_hours_config
                            .granted_work_hour_rules.monthly_employee
                            .workday_absent_granted
                        "
                      />
                      <label
                        for="granted_monthly_workday_absent_false"
                        class="ml-2"
                        >ไม่ให้</label
                      >
                    </td>
                  </tr>
                  <tr>
                    <td class="px-4 py-1 body-2 text-right grey lighten-3">
                      วันหยุดไม่มา
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="granted_monthly_day_off_absent_true"
                        :value="true"
                        v-model="
                          configWorkingHours.working_hours_config
                            .granted_work_hour_rules.monthly_employee
                            .day_off_absent_granted
                        "
                      />
                      <label
                        for="granted_monthly_day_off_absent_true"
                        class="ml-2"
                        >{{
                          `${configWorkingHours.working_hours_config.working_hours.hour}.${configWorkingHours.working_hours_config.working_hours.minute}`
                        }}
                        ช.ม.</label
                      >
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="granted_monthly_day_off_absent_false"
                        :value="false"
                        v-model="
                          configWorkingHours.working_hours_config
                            .granted_work_hour_rules.monthly_employee
                            .day_off_absent_granted
                        "
                      />
                      <label
                        for="granted_monthly_day_off_absent_false"
                        class="ml-2"
                        >ไม่ให้</label
                      >
                    </td>
                  </tr>
                  <tr>
                    <td class="px-4 py-1 body-2 text-right grey lighten-3">
                      วันนักขัติฯไม่มา
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="granted_monthly_public_holiday_absent_true"
                        :value="true"
                        v-model="
                          configWorkingHours.working_hours_config
                            .granted_work_hour_rules.monthly_employee
                            .public_holiday_absent_granted
                        "
                      />
                      <label
                        for="granted_monthly_public_holiday_absent_true"
                        class="ml-2"
                        >{{
                          `${configWorkingHours.working_hours_config.working_hours.hour}.${configWorkingHours.working_hours_config.working_hours.minute}`
                        }}
                        ช.ม.</label
                      >
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="granted_monthly_public_holiday_absent_false"
                        :value="false"
                        v-model="
                          configWorkingHours.working_hours_config
                            .granted_work_hour_rules.monthly_employee
                            .public_holiday_absent_granted
                        "
                      />
                      <label
                        for="granted_monthly_public_holiday_absent_false"
                        class="ml-2"
                        >ไม่ให้</label
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </v-card>
        <v-card outlined class="mt-4 pa-4">
          <div>
            <p class="body-2 mb-0" style="font-weight: 600">การให้ชั่วโมงหัก</p>
            <v-divider class="my-2"></v-divider>
            <p class="body-2 mb-1" style="font-weight: 500">พนักงานรายวัน</p>
            <div class="mt-2 d-flex">
              <table>
                <tbody>
                  <tr>
                    <td class="px-4 py-1 body-2 text-right grey lighten-3">
                      วันทำงานมา
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="deducted_daily_workday_present_true"
                        :value="true"
                        v-model="
                          configWorkingHours.working_hours_config
                            .deducted_work_hour_rules.daily_employee
                            .workday_present_deducted
                        "
                      />
                      <label
                        for="deducted_daily_workday_present_true"
                        class="ml-2"
                        >{{
                          `${configWorkingHours.working_hours_config.working_hours.hour}.${configWorkingHours.working_hours_config.working_hours.minute}`
                        }}
                        ช.ม.
                      </label>
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="deducted_daily_workday_present_false"
                        :value="false"
                        v-model="
                          configWorkingHours.working_hours_config
                            .deducted_work_hour_rules.daily_employee
                            .workday_present_deducted
                        "
                      />
                      <label
                        for="deducted_daily_workday_present_false"
                        class="ml-2"
                        >ไม่ให้</label
                      >
                    </td>
                  </tr>
                  <tr>
                    <td class="px-4 py-1 body-2 text-right grey lighten-3">
                      วันหยุดมา
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="deducted_daily_day_off_present_true"
                        :value="true"
                        v-model="
                          configWorkingHours.working_hours_config
                            .deducted_work_hour_rules.daily_employee
                            .day_off_present_deducted
                        "
                      />
                      <label
                        for="deducted_daily_day_off_present_true"
                        class="ml-2"
                        >{{
                          `${configWorkingHours.working_hours_config.working_hours.hour}.${configWorkingHours.working_hours_config.working_hours.minute}`
                        }}
                        ช.ม.</label
                      >
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="deducted_daily_day_off_present_false"
                        :value="false"
                        v-model="
                          configWorkingHours.working_hours_config
                            .deducted_work_hour_rules.daily_employee
                            .day_off_present_deducted
                        "
                      />
                      <label
                        for="deducted_daily_day_off_present_false"
                        class="ml-2"
                        >ไม่ให้</label
                      >
                    </td>
                  </tr>
                  <tr>
                    <td class="px-4 py-1 body-2 text-right grey lighten-3">
                      วันนักขัติฯมา
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="deducted_daily_public_holiday_present_true"
                        :value="true"
                        v-model="
                          configWorkingHours.working_hours_config
                            .deducted_work_hour_rules.daily_employee
                            .public_holiday_present_deducted
                        "
                      />
                      <label
                        for="deducted_daily_public_holiday_present_true"
                        class="ml-2"
                        >{{
                          `${configWorkingHours.working_hours_config.working_hours.hour}.${configWorkingHours.working_hours_config.working_hours.minute}`
                        }}
                        ช.ม.</label
                      >
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="deducted_daily_public_holiday_present_false"
                        :value="false"
                        v-model="
                          configWorkingHours.working_hours_config
                            .deducted_work_hour_rules.daily_employee
                            .public_holiday_present_deducted
                        "
                      />
                      <label
                        for="deducted_daily_public_holiday_present_false"
                        class="ml-2"
                        >ไม่ให้</label
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
              <v-divider vertical class="mx-6"></v-divider>
              <table>
                <tbody>
                  <tr>
                    <td class="px-4 py-1 body-2 text-right grey lighten-3">
                      วันทำงานไม่มา
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="deducted_daily_workday_absent_true"
                        :value="true"
                        v-model="
                          configWorkingHours.working_hours_config
                            .deducted_work_hour_rules.daily_employee
                            .workday_absent_deducted
                        "
                      />
                      <label
                        for="deducted_daily_workday_absent_true"
                        class="ml-2"
                        >{{
                          `${configWorkingHours.working_hours_config.working_hours.hour}.${configWorkingHours.working_hours_config.working_hours.minute}`
                        }}
                        ช.ม.</label
                      >
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="deducted_daily_workday_absent_false"
                        :value="false"
                        v-model="
                          configWorkingHours.working_hours_config
                            .deducted_work_hour_rules.daily_employee
                            .workday_absent_deducted
                        "
                      />
                      <label
                        for="deducted_daily_workday_absent_false"
                        class="ml-2"
                        >ไม่ให้</label
                      >
                    </td>
                  </tr>
                  <tr>
                    <td class="px-4 py-1 body-2 text-right grey lighten-3">
                      วันหยุดไม่มา
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="deducted_daily_day_off_absent_true"
                        :value="true"
                        v-model="
                          configWorkingHours.working_hours_config
                            .deducted_work_hour_rules.daily_employee
                            .day_off_absent_deducted
                        "
                      />
                      <label
                        for="deducted_daily_day_off_absent_true"
                        class="ml-2"
                        >{{
                          `${configWorkingHours.working_hours_config.working_hours.hour}.${configWorkingHours.working_hours_config.working_hours.minute}`
                        }}
                        ช.ม.</label
                      >
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="deducted_daily_day_off_absent_false"
                        :value="false"
                        v-model="
                          configWorkingHours.working_hours_config
                            .deducted_work_hour_rules.daily_employee
                            .day_off_absent_deducted
                        "
                      />
                      <label
                        for="deducted_daily_day_off_absent_false"
                        class="ml-2"
                        >ไม่ให้</label
                      >
                    </td>
                  </tr>
                  <tr>
                    <td class="px-4 py-1 body-2 text-right grey lighten-3">
                      วันนักขัติฯไม่มา
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="deducted_daily_public_holiday_absent_true"
                        :value="true"
                        v-model="
                          configWorkingHours.working_hours_config
                            .deducted_work_hour_rules.daily_employee
                            .public_holiday_absent_deducted
                        "
                      />
                      <label
                        for="deducted_daily_public_holiday_absent_true"
                        class="ml-2"
                        >{{
                          `${configWorkingHours.working_hours_config.working_hours.hour}.${configWorkingHours.working_hours_config.working_hours.minute}`
                        }}
                        ช.ม.</label
                      >
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="deducted_daily_public_holiday_absent_false"
                        :value="false"
                        v-model="
                          configWorkingHours.working_hours_config
                            .deducted_work_hour_rules.daily_employee
                            .public_holiday_absent_deducted
                        "
                      />
                      <label
                        for="deducted_daily_public_holiday_absent_false"
                        class="ml-2"
                        >ไม่ให้</label
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="mt-10">
            <p class="body-2 mb-1" style="font-weight: 500">พนักงานรายเดือน</p>
            <div class="mt-2 d-flex">
              <table>
                <tbody>
                  <tr>
                    <td class="px-4 py-1 body-2 text-right grey lighten-3">
                      วันทำงานมา
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="deducted_monthly_workday_present_true"
                        :value="true"
                        v-model="
                          configWorkingHours.working_hours_config
                            .deducted_work_hour_rules.monthly_employee
                            .workday_present_deducted
                        "
                      />
                      <label
                        for="deducted_monthly_workday_present_true"
                        class="ml-2"
                        >{{
                          `${configWorkingHours.working_hours_config.working_hours.hour}.${configWorkingHours.working_hours_config.working_hours.minute}`
                        }}
                        ช.ม.</label
                      >
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="deducted_monthly_workday_present_false"
                        :value="false"
                        v-model="
                          configWorkingHours.working_hours_config
                            .deducted_work_hour_rules.monthly_employee
                            .workday_present_deducted
                        "
                      />
                      <label
                        for="deducted_monthly_workday_present_false"
                        class="ml-2"
                        >ไม่ให้</label
                      >
                    </td>
                  </tr>
                  <tr>
                    <td class="px-4 py-1 body-2 text-right grey lighten-3">
                      วันหยุดมา
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="deducted_monthly_day_off_present_true"
                        :value="true"
                        v-model="
                          configWorkingHours.working_hours_config
                            .deducted_work_hour_rules.monthly_employee
                            .day_off_present_deducted
                        "
                      />
                      <label
                        for="deducted_monthly_day_off_present_true"
                        class="ml-2"
                        >{{
                          `${configWorkingHours.working_hours_config.working_hours.hour}.${configWorkingHours.working_hours_config.working_hours.minute}`
                        }}
                        ช.ม.</label
                      >
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="deducted_monthly_day_off_present_false"
                        :value="false"
                        v-model="
                          configWorkingHours.working_hours_config
                            .deducted_work_hour_rules.monthly_employee
                            .day_off_present_deducted
                        "
                      />
                      <label
                        for="deducted_monthly_day_off_present_false"
                        class="ml-2"
                        >ไม่ให้</label
                      >
                    </td>
                  </tr>
                  <tr>
                    <td class="px-4 py-1 body-2 text-right grey lighten-3">
                      วันนักขัติฯมา
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="deducted_monthly_public_holiday_present_true"
                        :value="true"
                        v-model="
                          configWorkingHours.working_hours_config
                            .deducted_work_hour_rules.monthly_employee
                            .public_holiday_present_deducted
                        "
                      />
                      <label
                        for="deducted_monthly_public_holiday_present_true"
                        class="ml-2"
                        >{{
                          `${configWorkingHours.working_hours_config.working_hours.hour}.${configWorkingHours.working_hours_config.working_hours.minute}`
                        }}
                        ช.ม.</label
                      >
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="deducted_monthly_public_holiday_present_false"
                        :value="false"
                        v-model="
                          configWorkingHours.working_hours_config
                            .deducted_work_hour_rules.monthly_employee
                            .public_holiday_present_deducted
                        "
                      />
                      <label
                        for="deducted_monthly_public_holiday_present_false"
                        class="ml-2"
                        >ไม่ให้</label
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
              <v-divider vertical class="mx-6"></v-divider>
              <table>
                <tbody>
                  <tr>
                    <td class="px-4 py-1 body-2 text-right grey lighten-3">
                      วันทำงานไม่มา
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="deducted_monthly_workday_absent_true"
                        :value="true"
                        v-model="
                          configWorkingHours.working_hours_config
                            .deducted_work_hour_rules.monthly_employee
                            .workday_absent_deducted
                        "
                      />
                      <label
                        for="deducted_monthly_workday_absent_true"
                        class="ml-2"
                        >{{
                          `${configWorkingHours.working_hours_config.working_hours.hour}.${configWorkingHours.working_hours_config.working_hours.minute}`
                        }}
                        ช.ม.</label
                      >
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="deducted_monthly_workday_absent_false"
                        :value="false"
                        v-model="
                          configWorkingHours.working_hours_config
                            .deducted_work_hour_rules.monthly_employee
                            .workday_absent_deducted
                        "
                      />
                      <label
                        for="deducted_monthly_workday_absent_false"
                        class="ml-2"
                        >ไม่ให้</label
                      >
                    </td>
                  </tr>
                  <tr>
                    <td class="px-4 py-1 body-2 text-right grey lighten-3">
                      วันหยุดไม่มา
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="deducted_monthly_day_off_absent_true"
                        :value="true"
                        v-model="
                          configWorkingHours.working_hours_config
                            .deducted_work_hour_rules.monthly_employee
                            .day_off_absent_deducted
                        "
                      />
                      <label
                        for="deducted_monthly_day_off_absent_true"
                        class="ml-2"
                        >{{
                          `${configWorkingHours.working_hours_config.working_hours.hour}.${configWorkingHours.working_hours_config.working_hours.minute}`
                        }}
                        ช.ม.</label
                      >
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="deducted_monthly_day_off_absent_false"
                        :value="false"
                        v-model="
                          configWorkingHours.working_hours_config
                            .deducted_work_hour_rules.monthly_employee
                            .day_off_absent_deducted
                        "
                      />
                      <label
                        for="deducted_monthly_day_off_absent_false"
                        class="ml-2"
                        >ไม่ให้</label
                      >
                    </td>
                  </tr>
                  <tr>
                    <td class="px-4 py-1 body-2 text-right grey lighten-3">
                      วันนักขัติฯไม่มา
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="deducted_monthly_public_holiday_absent_true"
                        :value="true"
                        v-model="
                          configWorkingHours.working_hours_config
                            .deducted_work_hour_rules.monthly_employee
                            .public_holiday_absent_deducted
                        "
                      />
                      <label
                        for="deducted_monthly_public_holiday_absent_true"
                        class="ml-2"
                        >{{
                          `${configWorkingHours.working_hours_config.working_hours.hour}.${configWorkingHours.working_hours_config.working_hours.minute}`
                        }}
                        ช.ม.</label
                      >
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="deducted_monthly_public_holiday_absent_false"
                        :value="false"
                        v-model="
                          configWorkingHours.working_hours_config
                            .deducted_work_hour_rules.monthly_employee
                            .public_holiday_absent_deducted
                        "
                      />
                      <label
                        for="deducted_monthly_public_holiday_absent_false"
                        class="ml-2"
                        >ไม่ให้</label
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </v-card>
        <v-card outlined class="mt-4 pa-4">
          <div>
            <p class="body-2 mb-0" style="font-weight: 600">
              การให้ชั่วโมงนักขัติฯ
            </p>
            <v-divider class="my-2"></v-divider>
            <p class="body-2 mb-1" style="font-weight: 500">พนักงานรายวัน</p>
            <div class="mt-2 d-flex">
              <table>
                <tbody>
                  <tr>
                    <td class="px-4 py-1 body-2 text-right grey lighten-3">
                      วันนักขัติฯ-มา
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="public_holiday_daily_public_holiday_present_true"
                        :value="true"
                        v-model="
                          configWorkingHours.working_hours_config
                            .public_holiday_work_hour_rules.daily_employee
                            .public_holiday_present_granted
                        "
                      />
                      <label
                        for="public_holiday_daily_public_holiday_present_true"
                        class="ml-2"
                        >{{
                          `${configWorkingHours.working_hours_config.working_hours.hour}.${configWorkingHours.working_hours_config.working_hours.minute}`
                        }}
                        ช.ม.
                      </label>
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="public_holiday_daily_public_holiday_present_false"
                        :value="false"
                        v-model="
                          configWorkingHours.working_hours_config
                            .public_holiday_work_hour_rules.daily_employee
                            .public_holiday_present_granted
                        "
                      />
                      <label
                        for="public_holiday_daily_public_holiday_present_false"
                        class="ml-2"
                        >ไม่ให้</label
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
              <v-divider vertical class="mx-6"></v-divider>
              <table>
                <tbody>
                  <tr>
                    <td class="px-4 py-1 body-2 text-right grey lighten-3">
                      วันนักขัติฯ-ไม่มา
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="public_holiday_daily_public_holiday_absent_true"
                        :value="true"
                        v-model="
                          configWorkingHours.working_hours_config
                            .public_holiday_work_hour_rules.daily_employee
                            .public_holiday_absent_granted
                        "
                      />
                      <label
                        for="public_holiday_daily_public_holiday_absent_true"
                        class="ml-2"
                        >{{
                          `${configWorkingHours.working_hours_config.working_hours.hour}.${configWorkingHours.working_hours_config.working_hours.minute}`
                        }}
                        ช.ม.</label
                      >
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="public_holiday_daily_public_holiday_absent_false"
                        :value="false"
                        v-model="
                          configWorkingHours.working_hours_config
                            .public_holiday_work_hour_rules.daily_employee
                            .public_holiday_absent_granted
                        "
                      />
                      <label
                        for="public_holiday_daily_public_holiday_absent_false"
                        class="ml-2"
                        >ไม่ให้</label
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="mt-10">
            <p class="body-2 mb-1" style="font-weight: 500">พนักงานรายเดือน</p>
            <div class="mt-2 d-flex">
              <table>
                <tbody>
                  <tr>
                    <td class="px-4 py-1 body-2 text-right grey lighten-3">
                      วันนักขัติฯ-มา
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="public_holiday_monthly_public_holiday_present_true"
                        :value="true"
                        v-model="
                          configWorkingHours.working_hours_config
                            .public_holiday_work_hour_rules.monthly_employee
                            .public_holiday_present_granted
                        "
                      />
                      <label
                        for="public_holiday_monthly_public_holiday_present_true"
                        class="ml-2"
                        >{{
                          `${configWorkingHours.working_hours_config.working_hours.hour}.${configWorkingHours.working_hours_config.working_hours.minute}`
                        }}
                        ช.ม.
                      </label>
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="public_holiday_monthly_public_holiday_present_false"
                        :value="false"
                        v-model="
                          configWorkingHours.working_hours_config
                            .public_holiday_work_hour_rules.monthly_employee
                            .public_holiday_present_granted
                        "
                      />
                      <label
                        for="public_holiday_monthly_public_holiday_present_false"
                        class="ml-2"
                        >ไม่ให้</label
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
              <v-divider vertical class="mx-6"></v-divider>
              <table>
                <tbody>
                  <tr>
                    <td class="px-4 py-1 body-2 text-right grey lighten-3">
                      วันนักขัติฯ-ไม่มา
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="public_holiday_monthly_public_holiday_absent_true"
                        :value="true"
                        v-model="
                          configWorkingHours.working_hours_config
                            .public_holiday_work_hour_rules.monthly_employee
                            .public_holiday_absent_granted
                        "
                      />
                      <label
                        for="public_holiday_monthly_public_holiday_absent_true"
                        class="ml-2"
                        >{{
                          `${configWorkingHours.working_hours_config.working_hours.hour}.${configWorkingHours.working_hours_config.working_hours.minute}`
                        }}
                        ช.ม.</label
                      >
                    </td>
                    <td class="px-4 py-1 body-2">
                      <input
                        type="radio"
                        id="public_holiday_monthly_public_holiday_absent_false"
                        :value="false"
                        v-model="
                          configWorkingHours.working_hours_config
                            .public_holiday_work_hour_rules.monthly_employee
                            .public_holiday_absent_granted
                        "
                      />
                      <label
                        for="public_holiday_monthly_public_holiday_absent_false"
                        class="ml-2"
                        >ไม่ให้</label
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </v-card>
        <div class="mt-6">
          <v-btn
            class="mr-4"
            color="primary"
            :disabled="
              !isConfigWorkingHoursDataChange ||
              (uiCtrl &&
                !uiCtrl.isEnable('btn:::company_config:working_hours:update'))
            "
            @click="onSaveConfigWorkingHours"
            >บันทึก</v-btn
          >
          <v-btn @click="resetConfigWorkingHours">ยกเลิก</v-btn>
        </div>
      </v-tab-item>
    </v-tabs-items>
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
  </v-container>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'

import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  name: 'WorkingHours',
  components: {
    ConfirmDialog,
  },
  data() {
    return {
      tab: 0,
      validationRules: {
        required: (v) =>
          (v !== null && v !== undefined && v !== '') || 'กรุณากรอกข้อมูล',
        positiveInteger: (v) => {
          if (!v) return true
          const num = parseInt(v)
          return (
            (!isNaN(num) && num > 0 && Number.isInteger(num)) ||
            'กรุณากรอกตัวเลขจำนวนเต็มบวก'
          )
        },
        nonNegativeInteger: (v) => {
          if (v === null || v === undefined || v === '') return true
          const num = parseInt(v)
          return (
            (!isNaN(num) && num >= 0 && Number.isInteger(num)) ||
            'กรุณากรอกตัวเลขจำนวนเต็มตั้งแต่ 0 ขึ้นไป'
          )
        },
        maxHours: (max) => (v) => {
          if (!v) return true
          const num = parseInt(v)
          return num <= max || `กรุณากรอกไม่เกิน ${max} ชั่วโมง`
        },
        maxMinutes: (max) => (v) => {
          if (!v) return true
          const num = parseInt(v)
          return num <= max || `กรุณากรอกไม่เกิน ${max} นาที`
        },
        maxDays: (max) => (v) => {
          if (!v) return true
          const num = parseInt(v)
          return num <= max || `กรุณากรอกไม่เกิน ${max} วัน`
        },
      },
      configWorkingHours: {
        working_hours_config: {
          working_hours: {},
          day_period: {},
          granted_work_hour_rules: {
            monthly_employee: {},
            daily_employee: {},
          },
          deducted_work_hour_rules: {
            monthly_employee: {},
            daily_employee: {},
          },
          public_holiday_work_hour_rules: {
            monthly_employee: {},
            daily_employee: {},
          },
        },
      },
      configWorkingHoursInit: {
        working_hours_config: {
          working_hours: {},
          day_period: {},
          granted_work_hour_rules: {
            monthly_employee: {},
            daily_employee: {},
          },
          deducted_work_hour_rules: {
            monthly_employee: {},
            daily_employee: {},
          },
          public_holiday_work_hour_rules: {
            monthly_employee: {},
            daily_employee: {},
          },
        },
      },
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      timeout: null,
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    isConfigWorkingHoursDataChange() {
      return !_.isEqual(this.configWorkingHours, this.configWorkingHoursInit)
    },
  },
  watch: {
    uiCtrl(value) {
      if (
        this.uiCtrl &&
        !this.uiCtrl.isEnable('menu:::company_config:working_hours')
      ) {
        this.$router.push({ name: 'Home' })
      } else if (value) {
        this.loadData()
      }
    },
  },
  created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'การคิดชั่วโมงงาน',
        disabled: true,
      },
    ])

    if (
      this.uiCtrl &&
      this.uiCtrl.isEnable('menu:::company_config:working_hours')
    ) {
      this.loadData()
    }
  },
  methods: {
    ...mapActions({
      fetchConfigWorkingHours: 'workingHours/fetchConfigWorkingHours',
      editConfigWorkingHours: 'workingHours/editConfigWorkingHours',
      fetchConfigWorkingHoursConstant:
        'workingHours/fetchConfigWorkingHoursConstant',
    }),
    onSaveConfigWorkingHours() {
      const { company_uuid } = this.$store.state.authentication.company
      const constantKeys = [
        'attendance_rule',
        'overtime_config',
        'start_late_from',
      ]
      const data = _.omit(this.configWorkingHours, constantKeys)

      this.$store.commit('SET_LOADING', true)

      this.editConfigWorkingHours({
        company_uuid,
        data,
      })
        .then(() => {
          this.$store.commit('SET_LOADING', false)

          const responseData = this.$store.state.workingHours.configWorkingHours
          const configWorkingHours = {
            ..._.pick(this.configWorkingHours, constantKeys),
            ...responseData,
          }

          this.configWorkingHours = JSON.parse(
            JSON.stringify(configWorkingHours)
          )
          this.configWorkingHoursInit = JSON.parse(
            JSON.stringify(configWorkingHours)
          )

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 4000,
            message: 'บันทึกข้อมูลสำเร็จ',
          }

          this.$store.commit('SET_SNACKBAR', snackbar)
        })
        .catch((error) => {
          this.$store.commit('SET_LOADING', false)

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    resetConfigWorkingHours() {
      this.configWorkingHours = JSON.parse(
        JSON.stringify(this.configWorkingHoursInit)
      )
    },
    async loadData() {
      try {
        const { company_uuid } = this.$store.state.authentication.company

        this.$store.state.loading = true

        const [workingHoursConstant, _] = await Promise.all([
          this.fetchConfigWorkingHoursConstant({ company_uuid }),
          this.fetchConfigWorkingHours({ company_uuid }),
        ])

        const configWorkingHours = {
          ...workingHoursConstant.working_hours_config,
          ...this.$store.state.workingHours.configWorkingHours,
        }

        this.configWorkingHours = JSON.parse(JSON.stringify(configWorkingHours))
        this.configWorkingHoursInit = JSON.parse(
          JSON.stringify(configWorkingHours)
        )
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.$store.commit('SET_LOADING', false)
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange(item) {
      this.confirmDialogDataChange = false
      this.nextRoute(item.data)
    },
    nextRoute(next) {
      this.timeout = setTimeout(() => {
        next()
      }, 200)
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.isConfigWorkingHoursDataChange) {
      this.confirmDialogDataChangeData = {
        title: 'ต้องการออกจากหน้านี้ใช่ไหม',
        text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการออกโดยที่ยังไม่บันทึกข้อมูล',
        value: '',
        item: {
          type: 'next',
          data: next,
        },
      }
      this.confirmDialogDataChange = true
    } else {
      this.nextRoute(next)
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  },
}
</script>
